import { lazy } from 'react';
import {
  CEB_STUDENT_MASTER_LIST,
  CEB_PROGRAM_MANAGEMENT,
  CEB_CLASS_MANAGEMENT,
  CEB_CENTRE_MANAGEMENT,
  CEB_LEVEL_MANAGEMENT,
  CEB_HOLIDAY_MANAGEMENT,
  CEB_SCHOOL_CONFIG,
  CEB_USER_ROLE_MANAGEMENT,
  CEB_STUDENT_DETAIL,
  CEB_STUDENT_PROFILE_CREATE,
  CEB_PROGRAM_DETAIL,
  CEB_CENTRE_MANAGEMENT_ADD,
  CEB_CLASS_DETAIL,
  CEB_CENTRE_MANAGEMENT_DETAIL,
  CEB_PROGRAM_CREATE,
  CEB_ADD_LEVEL,
  CEB_EDIT_LEVEL,
  CEB_FINANCE,
  CEB_CREATE_USER,
  CEB_CREATE_ROLE,
  CEB_EDIT_ROLE,
  CEB_EDIT_USER,
} from '../constants';

const AddEditRole = lazy(() =>
  import('components/views/Settings/UserAndRoleManagement/Role/AddEditRole')
);

const AddEditUser = lazy(() =>
  import('components/views/Settings/UserAndRoleManagement/User/AddEditUser')
);
const StudentMasterList = lazy(() =>
  import('components/views/CEB/StudentMasterList')
);
const CreateStudentProfile = lazy(() =>
  import('components/views/CEB/StudentMasterList/Create')
);
const ClassManagement = lazy(() =>
  import('components/views/CEB/ClassManagement')
);
const CentreManagement = lazy(() =>
  import('components/views/CEB/CentreManagement')
);
const AddCentreManagement = lazy(() =>
  import('components/views/CEB/CentreManagement/AddCentre')
);
const LevelManagement = lazy(() =>
  import('components/views/Settings/LevelManagement')
);
const ProgramManagement = lazy(() =>
  import('components/views/CEB/ProgramManagement')
);
const UserManagement = lazy(() =>
  import('components/views/Settings/UserAndRoleManagement')
);
const SchoolConfig = lazy(() =>
  import('components/views/Settings/General/SchoolConfig')
);
const HolidayManagement = lazy(() =>
  import('components/views/Settings/HolidayManagement')
);
const StudentDetail = lazy(() => import('components/views/CEB/StudentDetail'));
const ProgramDetail = lazy(() => import('components/views/CEB/ProgramDetail'));
const ClassDetail = lazy(() =>
  import('components/views/CEB/ClassManagement/ClassDetails')
);
const CentreDetail = lazy(() => import('components/views/CEB/CentreDetail'));
const CreateProgramme = lazy(() =>
  import('components/views/CEB/CreateProgramme')
);

const LevelDetail = lazy(() =>
  import('components/views/Settings/LevelManagement/LevelDetail')
);

const Finance = lazy(() => import('components/views/Finance'));

const cebStaffRoutes = [
  {
    url: CEB_STUDENT_MASTER_LIST,
    component: {
      default: StudentMasterList,
    },
  },
  {
    url: CEB_STUDENT_PROFILE_CREATE,
    component: {
      default: CreateStudentProfile,
    },
  },
  {
    url: CEB_PROGRAM_MANAGEMENT,
    component: {
      default: ProgramManagement,
    },
  },
  {
    url: CEB_CLASS_MANAGEMENT,
    component: {
      default: ClassManagement,
    },
  },
  {
    url: CEB_CENTRE_MANAGEMENT,
    component: {
      default: CentreManagement,
    },
  },
  {
    url: CEB_CENTRE_MANAGEMENT_ADD,
    component: {
      default: AddCentreManagement,
    },
  },
  {
    url: CEB_LEVEL_MANAGEMENT,
    component: {
      default: LevelManagement,
    },
  },
  {
    url: CEB_EDIT_LEVEL,
    component: {
      default: LevelDetail,
    },
  },
  {
    url: CEB_ADD_LEVEL,
    component: {
      default: LevelDetail,
    },
  },
  {
    url: CEB_USER_ROLE_MANAGEMENT,
    component: {
      default: UserManagement,
    },
  },
  {
    url: CEB_CREATE_ROLE,
    component: {
      default: AddEditRole,
    },
  },
  {
    url: CEB_EDIT_ROLE,
    component: {
      default: AddEditRole,
    },
  },
  {
    url: CEB_CREATE_USER,
    component: {
      default: AddEditUser,
    },
  },
  {
    url: CEB_EDIT_USER,
    component: {
      default: AddEditUser,
    },
  },
  {
    url: CEB_HOLIDAY_MANAGEMENT,
    component: {
      default: HolidayManagement,
    },
  },
  {
    url: CEB_SCHOOL_CONFIG,
    component: {
      default: SchoolConfig,
    },
  },
  {
    url: CEB_STUDENT_DETAIL,
    component: {
      default: StudentDetail,
    },
  },
  {
    url: CEB_PROGRAM_CREATE,
    component: {
      default: CreateProgramme,
    },
  },
  {
    url: CEB_PROGRAM_DETAIL,
    component: {
      default: ProgramDetail,
    },
  },
  {
    url: CEB_CLASS_DETAIL,
    component: {
      default: ClassDetail,
    },
  },
  {
    url: CEB_CENTRE_MANAGEMENT_DETAIL,
    component: {
      default: CentreDetail,
    },
  },
  {
    url: CEB_FINANCE,
    component: {
      default: Finance,
    },
  },
];

export default cebStaffRoutes;
